import AdminSpecialComponent from "../components/admin/admin.special.component";

const AdminSpecialBookingPage = () => {
    return <AdminSpecialComponent />;
  };
  
  export default AdminSpecialBookingPage;